module.exports = __webpack_public_path__ + "static/media/BigVenn.82e0fd1f.JPG";